module.exports = __webpack_public_path__ + "5cb5613ccee2914cb95f461eadceb4ce.jpg";